import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { task } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface FetchTasksByIdsParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchTasksByIdsApiQuery extends ApiQuery<
	TaskOutput[],
	FetchTasksByIdsParams
> {
	client = 'iam';
	document = gql`
		query FetchTasksByIds($ids: [UUID]!) {
			fetchTasksByIds(ids: $ids) {
				...Task
			}
		}
		${task}
	`;
	method = 'fetchTasksByIds';
}
